/** @desc eventId和唯一key的映射表 */

export const eventMap = {
  // 购物车优惠券曝光
  sailing_c_x_cartcoupon_realexposure_sw: 'coupon_id',
  sailing_c_x_top_item_realexposure_sw: 'item_id',
  sailing_c_x_landingpage_coupon_product_sw: 'product_id',
  sailing_c_x_couponpage_shop_select_shop_sw: 'shop_id',
};
